// src/prototype/enterprise/EnterpriseSubNav.tsx
// ============================================================
// ENTERPRISE SUB-NAV (navy) — the enterprise section nav, rendered ONLY in Enterprise mode
// (its absence in Standard is the before/after delta). Matches Enterprise Prototype.dc.html:
// full-width navy bar, "ENTERPRISE" eyebrow, Portfolio · Scenarios · Decisions · Reports,
// right-aligned "as of {run}" stamp.
//
// The "as of {run}" label follows the shared selected run (useEnterpriseRun) that the
// Portfolio surface's timeline control sets — resolved to a label via the spine adapter.
// ============================================================

import React from 'react';
import { NavLink } from 'react-router-dom';
import { getRuns } from '../data/adapters/enterpriseSpine';
import { useEnterpriseRun } from './useEnterpriseRun';
import { ENTERPRISE_TABS as TABS } from './enterpriseTabs';

export const EnterpriseSubNav: React.FC = () => {
  const { runId } = useEnterpriseRun();
  const runs = getRuns();
  const asOfLabel = runs.find((r) => r.run_id === runId)?.label ?? runs[0]?.label ?? '';
  return (
  <nav className="bg-[#18365E]" aria-label="Enterprise sections">
    <div className="px-6 py-2.5 flex items-center gap-1">
      <span className="mr-3 text-[9.5px] font-bold uppercase tracking-[0.14em] text-[#8fa5c4]">
        Enterprise
      </span>
      {TABS.map(({ to, label }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            `px-3.5 py-1.5 rounded-md text-[11.5px] transition-colors ${
              isActive ? 'bg-white/[0.16] text-white font-semibold' : 'text-[#b7c4d8] font-medium hover:text-white'
            }`
          }
        >
          {label}
        </NavLink>
      ))}
      <span className="ml-auto text-[10.5px] text-[#b7c4d8]">
        as of <span className="text-white font-semibold">{asOfLabel}</span>
      </span>
    </div>
  </nav>
  );
};

export default EnterpriseSubNav;
